export const assessmentTemplate = [
  {
    _id: "botpressCUCards",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rlund3",
      createdDate: "2025-12-10T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "botpressCUCards",
      omniTypeVersion: 1,
      title: "Customer Questions about Cards",
      description: "This is a collection of card-related queries.",
      duration: "A little less than a bit",
      directions: "Do not close your browser window until the assessment is complete.",
      attribution: "Omniscia AI Team. All Rights Reserved.",
      validated: true,
      selfAssessment: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "BOT076",
          numberText: "1",
          text: "How do I activate my card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT077",
          numberText: "2",
          text: "How do I report a lost card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT078",
          numberText: "3",
          text: "How do I report a stolen card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT079",
          numberText: "4",
          text: "How do I freeze my card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT080",
          numberText: "5",
          text: "How do I unfreeze my card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT081",
          numberText: "6",
          text: "How do I change my card PIN?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT082",
          numberText: "7",
          text: "Why was my card declined?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT083",
          numberText: "8",
          text: "How do I order a replacement card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT084",
          numberText: "9",
          text: "How long does it take to receive a new card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT085",
          numberText: "10",
          text: "How do I see my card transactions?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT086",
          numberText: "11",
          text: "How do I dispute a card transaction?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT087",
          numberText: "12",
          text: "How do I add my card to Apple Pay or Google Pay?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT088",
          numberText: "13",
          text: "How do I set spending limits on my card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT089",
          numberText: "14",
          text: "How do I block international transactions?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT090",
          numberText: "15",
          text: "How do I report card fraud?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT091",
          numberText: "16",
          text: "How do I get a credit card?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT092",
          numberText: "17",
          text: "How do I increase my credit limit?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT093",
          numberText: "18",
          text: "How do I pay my credit card bill?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT094",
          numberText: "19",
          text: "How do I see my credit card statement?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT095",
          numberText: "20",
          text: "How do I change my billing address?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT096",
          numberText: "21",
          text: "Why is my card transaction pending?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT097",
          numberText: "22",
          text: "How do I add an authorized user?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT098",
          numberText: "23",
          text: "How do I remove an authorized user?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT099",
          numberText: "24",
          text: "How do I set up card alerts?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT100",
          numberText: "25",
          text: "How do I get a temporary card number?",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
      ],

      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "botpressCUCards",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
